import React from 'react';
import * as Styles from './ResendCode.styles';
import { Button } from 'gatorcomponents';

const ResendCode = ({
  resendEnabled,
  resendCode,
  loadingResend,
  time,
  twoFactorAuthLocale,
  testId,
}) => {
  const buttonLabel = twoFactorAuthLocale.validateCodeModal.resendCodeButtonLabel(time);

  return (
    <Styles.ResendWrapper>
      <Styles.ResendButtonHelperText>
        {twoFactorAuthLocale.validateCodeModal.resendButtonHelperText}
      </Styles.ResendButtonHelperText>
      <Button
        type="text"
        variant="secondary"
        label={buttonLabel}
        onClick={resendCode}
        loading={loadingResend}
        disabled={loadingResend || !resendEnabled}
        testId={`${testId}__resend-button`}
      />
    </Styles.ResendWrapper>
  );
};

export default ResendCode;
